
import React from 'react';
import { Label } from '@/components/ui/label';
import { Input } from '@/components/ui/input';
import { FormStepProps } from '../types';

const TransportConfigStep: React.FC<FormStepProps> = ({ 
  formData, 
  handleChange,
  availableProtocols = [],
  errors = {}
}) => {
  return (
    <div className="space-y-6">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="space-y-2">
          <Label htmlFor="transportType">Transport Type</Label>
          <select
            id="transportType"
            name="transportType"
            value={formData.transportType}
            onChange={handleChange}
            className="flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-base ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm"
          >
            <option value="">Select Transport Type</option>
            <option value="Default">Default</option>
            <option value="MQTT">MQTT</option>
            <option value="CoAP">CoAP</option>
            <option value="LWM2M">LWM2M</option>
            <option value="SNMP">SNMP</option>
          </select>
        </div>
        
        <div className="space-y-2">
          <Label htmlFor="protocol">Protocol</Label>
          <select
            id="protocol"
            name="protocol"
            value={formData.protocol}
            onChange={handleChange}
            className="flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-base ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm"
            disabled={!formData.transportType}
          >
            <option value="">Select Protocol</option>
            {availableProtocols.map(protocol => (
              <option key={protocol} value={protocol}>{protocol}</option>
            ))}
          </select>
          {!formData.transportType && (
            <p className="text-xs text-muted-foreground mt-1">Please select a Transport Type first</p>
          )}
        </div>
        
        <div className="space-y-2">
          <Label htmlFor="ipAddress">IP Address</Label>
          <Input
            id="ipAddress"
            name="ipAddress"
            value={formData.ipAddress}
            onChange={handleChange}
            placeholder="e.g. 192.168.1.100"
            className={errors.ipAddress ? "border-red-500" : ""}
          />
          {errors.ipAddress && (
            <p className="text-xs text-red-500 mt-1">{errors.ipAddress}</p>
          )}
        </div>
        
        <div className="space-y-2">
          <Label htmlFor="port">Port</Label>
          <Input
            id="port"
            name="port"
            value={formData.port}
            onChange={handleChange}
            placeholder="e.g. 1883"
            className={errors.port ? "border-red-500" : ""}
          />
          {errors.port && (
            <p className="text-xs text-red-500 mt-1">{errors.port}</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default TransportConfigStep;
